import { UseQueryStateResult } from '@reduxjs/toolkit/dist/query/react/buildHooks.d'
import { createApi } from '@reduxjs/toolkit/query/react'

import baseQueryInterceptor from '@api/base-query-interceptor'
import { ApiResponse } from '@api/types/api-response.type'

import { getUserEmail } from '@utilities/helper'

import { Unit } from '@adUtilities/types/apartment'

export interface Level {
  level: string
  data: Array<Unit>
  height: number
}

interface BlockInterface {
  label: string
  order: number
  levels: {
    [key: string]: {
      order: number
      label: string
      units: {
        [key: string]: Unit
      }
    }
  }
}

export interface BlockCollectionInterface {
  [key: string]: BlockInterface
}

type BuildingType = {
  projectName: string
}

export const buildingApi = createApi({
  reducerPath: 'buildingApi',
  baseQuery: baseQueryInterceptor,
  endpoints: (builder) => ({
    getBuilding: builder.query<ApiResponse<Array<Level>>, BuildingType>({
      query: (params: BuildingType) => ({
        url: `/v1/${params.projectName}/building?user_name=${getUserEmail()}`,
        method: 'get',
      }),
    }),
  }),
})

export const selectFromResult = ({
  data,
  isLoading,
  isError,
  status,
  error,
  isFetching,
}: UseQueryStateResult<any, any>): {
  building: Level[]
  blockOrders: string[]
  isLoaded: boolean
  isError: boolean
  errorStatus: number
  status: string
  isFetching: boolean
} => {
  const blockOrders = data?.data?.blockOrders || []
  const levels = data?.data?.lists || []

  const sortedLevels = levels.toSorted(
    (itemA: Level, itemB: Level) => (itemA?.height || 0) - (itemB?.height || 0)
  )

  const isSingleBlock = blockOrders.length === 1

  const resetLevelBlockIds = (levels: Level[]) =>
    levels.map((level) => ({
      ...level,
      data: level?.data?.map((levelData) => ({
        ...levelData,
        blockId: null,
      })),
    }))

  return {
    building: isSingleBlock ? resetLevelBlockIds(sortedLevels) : sortedLevels,
    blockOrders: isSingleBlock ? [] : blockOrders,
    isLoaded: !isLoading,
    isError,
    status,
    errorStatus: error?.status,
    isFetching,
  }
}

export const { useGetBuildingQuery } = buildingApi
